export const state = {
  role: undefined
};
